


export enum PostProcessingOutputType {

    CustomPlots = "custom-plots",
    CustomTables = "custom-tables"

}